
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_63f1c_17",
  "full-width": "awsui_full-width_8cbea_63f1c_44",
  "refresh": "awsui_refresh_8cbea_63f1c_47",
  "disabled": "awsui_disabled_8cbea_63f1c_53",
  "selected": "awsui_selected_8cbea_63f1c_116",
  "icon": "awsui_icon_8cbea_63f1c_127",
  "with-text": "awsui_with-text_8cbea_63f1c_131",
  "with-no-text": "awsui_with-no-text_8cbea_63f1c_140",
  "root": "awsui_root_8cbea_63f1c_145",
  "segment-part": "awsui_segment-part_8cbea_63f1c_177",
  "grouped": "awsui_grouped_8cbea_63f1c_201",
  "grouped-only": "awsui_grouped-only_8cbea_63f1c_201",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_63f1c_205",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_63f1c_216",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_63f1c_220",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_63f1c_226",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_63f1c_230",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_63f1c_234",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_63f1c_240",
  "grouped-end-action-horizontal-last": "awsui_grouped-end-action-horizontal-last_8cbea_63f1c_244",
  "grouped-end-action-horizontal-only": "awsui_grouped-end-action-horizontal-only_8cbea_63f1c_244",
  "grouped-end-action-vertical-first": "awsui_grouped-end-action-vertical-first_8cbea_63f1c_248",
  "grouped-end-action-vertical-last": "awsui_grouped-end-action-vertical-last_8cbea_63f1c_248",
  "grouped-end-action-vertical-only": "awsui_grouped-end-action-vertical-only_8cbea_63f1c_248",
  "select": "awsui_select_8cbea_63f1c_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_63f1c_265",
  "segment-count-3": "awsui_segment-count-3_8cbea_63f1c_272",
  "segment-count-4": "awsui_segment-count-4_8cbea_63f1c_279",
  "segment-count-5": "awsui_segment-count-5_8cbea_63f1c_286",
  "segment-count-6": "awsui_segment-count-6_8cbea_63f1c_293",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_63f1c_300"
};
  